import React from "react";
import logo from "../Assets/images/logo-white.svg";
import logo2 from "../Assets/images/logo.svg";
import { Link } from "react-router-dom";
import { FaFileAlt, FaSearchDollar, FaClipboardCheck, FaQuestionCircle } from "react-icons/fa";
import { menuData } from "./MainMenu";

const Footer = () => {
  return (
    <div className="footer-area secondary-bg">
      <div className="container">
        <div className="row pt-80 pb-80 row-gap-40">
          <div className="col-lg-4">
            <div className="footer-action">
              <Link to="/">
                <img src={logo} alt="WBC Solutions" className="white-logo" />
                <img src={logo2} alt="WBC Solutions" className="black-logo" />
              </Link>
              <div className="pt-50">
                <label className="fs-18 fw-bold text-white pb-3">
                  Audit fournisseur, pricing et récupération de marge
                </label>
                <p className="fs-18 text-white">
                  Mission dimensionnée selon la taille de l'entreprise, le nombre de fournisseurs, le volume de factures et le périmètre documentaire.
                </p>
                <Link to="/contact" className="primary-btn footer-cta br-10 fw-semibold">
                  Préparer une proposition
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="footer-wedged ms-lg-5 ps-lg-4">
              <div className="footer-wedged-item">
                <div className="fs-18 fw-bold text-white pb-25">Navigation</div>
                <ul>
                  {menuData.map((item) => (
                    <li key={item.url}>
                      <Link to={item.url}>{item.text}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="footer-wedged-item">
                <div className="fs-18 fw-bold text-white pb-25">Contact</div>
                <ul>
                  <li><Link to="tel:+33671641937">+(33) 06 71 64 19 37</Link></li>
                  <li><Link to="mailto:wbc1@consultant.com">wbc1@consultant.com</Link></li>
                  <li><Link to="/knowledge-catalog">Méthodologie d'audit</Link></li>
                  <li><Link to="/services">Audit conditions tarifaires, FEC, baux, double règlement</Link></li>
                </ul>
              </div>
              <div className="footer-wedged-item">
                <div className="fs-18 fw-bold text-white pb-25">Expertise</div>
                <ul>
                  <li><Link to="/knowledge-catalog"><FaSearchDollar /> Méthode de détection</Link></li>
                  <li><Link to="/knowledge-catalog"><FaClipboardCheck /> Dossier de preuve</Link></li>
                  <li><Link to="/knowledge-catalog"><FaQuestionCircle /> FAQ dirigeants</Link></li>
                  <li><Link to="/knowledge-catalog"><FaFileAlt /> Livrables et tarification</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="copyright">
              <div className="fs-18 text-white">Copyright © 2026 WBC. Tous droits réservés.</div>
              <div className="fs-18 text-white">Audit de marge perdue | Pricing | Accords fournisseurs</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;